import platform from 'platform-detect';

import {
  isAndroidWrapper,
  isIosWrapper,
} from '@/utilities/helpers/wrapperHelpers';

export type GLSPlatformType =
  | 'ANDROID_APP'
  | 'IOS_APP'
  | 'ANDROID_WEB'
  | 'IOS_WEB'
  | 'DESKTOP';

type GlsOs = 'WINDOWS' | 'MAC' | 'ANDROID' | 'IOS';

const getGlsUserOS = (): GlsOs => {
  if (platform.macos) {
    return 'MAC';
  }
  if (platform.android) {
    return 'ANDROID';
  }
  if (platform.ios) {
    return 'IOS';
  }

  return 'WINDOWS';
};

export const getGlsPlatformType = (): GLSPlatformType => {
  if (isAndroidWrapper()) {
    return 'ANDROID_APP';
  }

  if (isIosWrapper()) {
    return 'IOS_APP';
  }

  const os = getGlsUserOS();

  if (os === 'ANDROID') {
    return 'ANDROID_WEB';
  }

  if (os === 'IOS') {
    return 'IOS_WEB';
  }

  return 'DESKTOP';
};
